import { startOfTomorrow } from 'date-fns';

const RULES_KEY = 'role_based_rules';
const RULES_EXPIRATION = 'role_based_rules_expiration';
const ROLE_KEY = 'role';
const IMPERSONATION_EXPIRES_AT_KEY = 'impersonation_expires_at';
const SAVED_ACCOUNT_LOCATION_ID_KEY = 'savedAccountLocationId';

export const clearAuthData = () => {
  removeRules();
  removeImpersonationExpiresAt();
};

export const clearImpersonationData = () => {
  removeImpersonationExpiresAt();
};

// Just an id — callers must validate it against the current account before trusting it.
export const getSavedAccountLocationId = () => getItem(SAVED_ACCOUNT_LOCATION_ID_KEY);
export const setSavedAccountLocationId = (locationId: number | string) =>
  setItem(SAVED_ACCOUNT_LOCATION_ID_KEY, String(locationId));
export const removeSavedAccountLocationId = () => removeItem(SAVED_ACCOUNT_LOCATION_ID_KEY);

export const setRules = (rules) => {
  setItem(RULES_KEY, JSON.stringify(rules));
  setItem(RULES_EXPIRATION, JSON.stringify(startOfTomorrow()));
};
export const getRules = () => {
  const rules = getItem(RULES_KEY);

  return rules ? JSON.parse(rules) : null;
};

export const removeRules = () => {
  removeItem(RULES_KEY);
  removeItem(RULES_EXPIRATION);
};

export const getRulesExpiration = () => {
  const getExpiration = getItem(RULES_EXPIRATION);
  const expiration = getExpiration && JSON.parse(getExpiration);
  const rules = getRules();

  return expiration && rules ? new Date(expiration) : null;
};

export const getRole = () => getItem(ROLE_KEY);
export const setRole = (role) => setItem(ROLE_KEY, role);

export const setImpersonationExpiresAt = (expiresAt) => setItem(IMPERSONATION_EXPIRES_AT_KEY, expiresAt);
export const getImpersonationExpiresAt = () => getItem(IMPERSONATION_EXPIRES_AT_KEY);
export const removeImpersonationExpiresAt = () => removeItem(IMPERSONATION_EXPIRES_AT_KEY);

// The browser does not support or is blocking cookies from being set.
const localStorage = (window.navigator.cookieEnabled && window.localStorage) || null;

const setItem = (key, value) => localStorage?.setItem(key, value);
const getItem = (key) => localStorage?.getItem(key);
const removeItem = (key) => localStorage?.removeItem(key);
